import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import ContractView from "@/common/components/Entity/Contract/View/ContractView";
import { ViewVariant } from "@/common/ts/layout";
import { AccessoryCheckDto } from "@/core/api/generated/v1";

interface Props {
  accessoryCheck: AccessoryCheckDto;
}

export default function ContractTabContent({ accessoryCheck }: Props) {
  return (
    <PageTabContent sx={{ px: 0 }}>
      <Stack direction='column' spacing={2}>
        <ContractView
          contractId={accessoryCheck.contract?.id}
          contract={undefined}
          displayProps={{
            breadcrumbs: false,
            header: false,
            actions: true,
            viewVariant: ViewVariant.Tab,
          }}
          headerProps={{
            withLink: true,
            typographyProps: pageTabHeaderTypographyProps.title,
          }}
          onDelete={null}
        />
      </Stack>
    </PageTabContent>
  );
}
